export default "__VITE_ASSET__e7f678e7__"